import React from 'react';
import './RegistrationFooter.scss';
import { selectableLanguages } from '../../../lang/config';
import DropDown from '../../../components/DropDown/DropDown';

// Example: languageSelection = [{id: 'Eng', displayName: 'English'}, {id: 'FR', displayName: 'French'}];
const RegistrationFooter = ({
  languageSelection,
  selectedLanguage,
  onChangeLanguage,
}) => {
  const onChange = (data) => {
    onChangeLanguage(data);
  };

  if (languageSelection && !onChangeLanguage) {
    console.error(`onChangeLanguage function was not supplied
            please supply one, or remove languageSelection array`);
  }
  let markup = <div className='btn-group padTop'></div>;
  if (languageSelection && languageSelection.length > 0 && onChangeLanguage) {
    const currentLanguage = selectedLanguage || languageSelection[0];
    markup = (
      <DropDown
        onChange={onChange}
        defaultSelected={currentLanguage}
        values={selectableLanguages}
      />
    );
  }
  return <div className='registration--footer'>{markup}</div>;
};

export default RegistrationFooter;
